/* eslint-disable max-lines */
export default {
  title: {
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legal',
    identityConcession: 'Identity concession',
    loginEmployees: 'Login employees',
    loginPartners: 'Login partner',
    selectionFlow: 'Selection of flow',
    campsList: 'Management of camps',
    tasksList: 'List of tasks',
    papsList: 'List of PAPS',
    transportationList: 'Management of transportation',
    transportList: 'Transport list',
    acts: 'Vehicle fleet',
    act: 'Minutes detail',
    okData: 'Data saved successfully',
    identityDriver: 'Identity driver',
    signData: 'Check your data',
    signCompleted: 'Act signed',
    oidcCallback: 'Waiting...',
    checkIn: 'Delivery certificate',
    checkOut: 'Return certificate',
    checkSubstitution: 'Act of substitution',
    accessDenied: 'Access Denied',
    carDetail: 'Car detail',
    carTasks: 'Car tasks',
    papDetail: 'Pap detail',
    discrepancyDetail: 'Discrepancies detail',
    checksClient: 'Checks cliente',
    checksTransfer: 'Checks transfer',
    uploadDocumentOffline: 'Act offline'
  },
  sectionTitles: {
    damages: 'Damages',
    inDamages: 'Interior damages',
    outDamages: 'Exterior damages',
    loadDamageImages: 'Images',
    leaseData: 'Lease Data',
    inAccessories: 'Interior accessories',
    outAccessories: 'Exterior accessories',
    adjusts: 'Settings',
    deliveryData: 'Delivery data',
    deliveryAddress: 'Delivery address',
    frontTires: 'Front tires',
    rearTires: 'Rear tires',
    deliveryTransportData: 'Vehicle transport data'
  },
  message: {
    generic: {
      checkAccess: 'Verifying access',
      loadingData: 'Loading data',
      loadingDocuments: 'Loading documents',
      thankSoMuch: 'Thank you so much',
      permissionValidation: 'Validating permissions',
      updatingKms: 'Updating kilometers',
      updatingState: 'Updating task state',
      withPlate: 'with plate',
      rangeDateFilterTaskList:
        'You must select a registration or a field and a date range of no more than 31 days'
    },
    success: {
      updatedKm: 'Kilometers updated successfully',
      updatedTaskState: 'Task state updated successfully',
      obtainedAct: 'Act obtained correctly',
      discrepancyDetail: 'Detail of discrepancies obtained correctly',
      documentSign: 'Document signed correctly'
    },
    error: {
      oidcLoginError: 'Something went wrong at the start of the session!',
      accessDeniedTitle: 'Access Denied',
      accessDeniedText:
        'You do not have permissions to access the application. Please contact your administrator.',
      accessDeniedReturn: 'Return to home page',
      tryLater: 'Please try again later.',
      genericErrorCall: 'An error occurred while processing your request.',
      noVehicleRecords: 'There are no vehicles to display.',
      noPapsRecords: 'There are no PAPs to display.',
      noTransportRecords: 'There are no transports to display.',
      saveSign: 'An error occurred while saving the signature.',
      removeSign: 'An error occurred while deleting the signature.',
      documentSign: 'An error occurred while signing the document'
    },
    warning: {
      notDocumentations: 'We have not obtained documentation for the upload at this time.'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    loader: {
      assignDriver: 'Assigning driver...',
      changeStateToFinished: 'Changing status to finished...',
      getDiscrepancy: 'Obtaining details of the discrepancy...',
      passStateEnd: 'Passing status to finished...',
      transportAccept: 'Accepting transport...',
      transportDeny: 'Canceling transport...',
      transportReject: 'Canceling transport...',
      transportUnassign: 'Unassigning transport...',
      cancelAssociated: 'Canceling associated act'
    },
    header: {
      account: {
        logout: 'Logout'
      }
    },
    button: {
      btnBack: 'Back',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
      btnClose: 'Close',
      btnCreate: 'Create',
      btnConfirm: 'Confirm',
      btnChange: 'Change',
      btnDelete: 'Delete',
      btnDeleteSignature: 'Erase',
      btnRecord: 'Save',
      btnClear: 'Clear',
      btnAcceptAndContinue: 'Accept and continue',
      btnSearch: 'Search',
      btnCleanFilters: 'Clear filters',
      btnAddAttorney: 'Add new Attorney',
      btnRemoveAttorney: 'Remove attorney',
      btnsign: 'Sign now',
      btnYes: 'Yes',
      btnNo: 'No',
      btnValidating: 'Validating...',
      btnCancelPickup: 'Cancel pickup',
      btnDriverGuide: 'Driver guide',
      btnContinue: 'Continue',
      btnCancel125: 'Cancel the return',
      btnCancel124: 'Cancel pickup',
      btnCancel129: 'Cancel the return',
      btnCancel128: 'Cancel pickup',
      btnCancel123: 'Cancel substitution',
      btnBackToList: 'Back to list',
      btnBackToCarDetail: 'Back to car detail',
      btnSignDocument: 'Sign document'
    },
    links: {
      legalNotice: 'Legal notice',
      dataPrivacy: 'Data privacy',
      cookies: 'Cookies',
      downloadAct: 'Download act'
    },
    label: {
      step1: 'Login',
      accordionIdentity: 'Confirm your identity',
      allDataRequired: 'All data are required',
      titleLogin: 'Login',
      subTitleLogin: 'Enter your login hint',
      loginDescription:
        'To access you must be registered as a partner. For any questions, contact your commercial advisor.',
      checkRememberMe: 'Remember me',
      noRecords: 'There are no records to display.',
      noVehicleRecords: 'There are no vehicles to display.',
      assignDriver: 'Assign driver',
      signStatus: {
        default: 'Draw your signature in the blank space.',
        saving: 'Saving signature',
        saved: 'Saved signature',
        deleting: 'Deleting signature',
        sending: 'Sending signature',
        signed: 'Signed'
      }
    },
    checkbox: {
      billed: 'Billed',
      mounted: 'Mounted',
      componentsOK: 'Key, wheel, jack and triangle in perfect condition',
      documentation: 'Documentation',
      spareWheel: 'Spare wheel',
      tools: 'Tools',
      breakdownKit: 'Puncture kit',
      secondkey: '2º Key',
      dataSheet: 'Data sheet',
      circulationPermit: 'Circulation permit',
      stickerItv: 'Updated ITV sticker',
      environmentalDevice: 'Environmental device',
      ftPc: 'FT / PC',
      maintenanceRegisters: 'Book Mtto/Gtia',
      manualFcte: 'Manual Fcte.',
      insurance: 'Insurance',
      specialAcc: 'Special accessory',
      parabrisas: 'Windshield',
      capo: 'Hood',
      'paragolpes-delantero': 'Front bumper',
      'faros-delanteros': 'Headlights',
      'costado-izquierdo': 'Left side',
      'porton-trasero': 'Rear door',
      'luneta-trasera': 'Rear window',
      'paragolpes-traseros': 'Rear bumper',
      'faros-traseros': 'Rear lights',
      'costado-derecho': 'Right side',
      'llantas-y-tapacubos': 'Rims and hubcaps',
      'techo-capota': 'Roof / Hood',
      antena: 'Antenna',
      cubrecarter: 'Carter cover',
      withDamages: 'With damages',
      withoutDamages: 'Without damages'
    },
    placeholder: {
      idProvider: 'Id Provider',
      idCustomer: 'Id Customer',
      date: 'Date',
      dateAndHours: 'Date and hours',
      dateBackinBase: 'Date and time of departure from Carflex base',
      kmBackinBase: 'Kilometers departure from Carflex base',
      cifConcession: 'CIF Concession',
      vehicleId: 'Vehicle Id',
      vin: 'Vin',
      lessee: 'lessee',
      cifnif: 'CIF/NIF',
      numContract: 'Num contract lessee',
      customerData: 'Customer information',
      giverData: 'Deliverer information',
      driverData: 'Data of the person receiving the vehicle',
      name: 'Name',
      nameComplete: 'Name and Surname',
      lastname: 'Surname',
      lastname2: 'Second surname',
      dni: 'DNI',
      drivingLicenseDueDate: 'Due Date Driving License',
      carData: 'Car Information',
      brand: 'Brand',
      measures: 'Measures',
      modelName: 'Model',
      specialAccDescription: 'Special accessory description',
      remarks: 'Remarks',
      currentKilometers: 'Current Kilometers',
      colorName: 'Color',
      deliveryCity: 'Delivery City',
      documentationDeliveredData: 'Documentation Delivered',
      equipmentDeliveredData: 'Equipment Delivered',
      genre: 'Genre',
      profession: 'Profession',
      deliveryKm: 'Kilometres delivery',
      birthDate: 'Borth Date',
      maritalStatus: 'Marital Status',
      email: 'Email',
      mobilePrefix: 'Prefix',
      mobilePhone: 'Mobile Phone',
      streetType: 'Street Type',
      allStreetType: 'Street/Place/Avenue',
      state: 'State',
      address: 'Address',
      deliveryAddressCheckIn: 'Delivery address',
      deliveryAddressCheckOut: 'Return address',
      bringBackinBase: 'Delivery on carflex base',
      postCode: 'Post Code',
      town: 'Town',
      documentTypes: 'Document Type',
      documentId: 'Document Number (DNI, NIE)',
      businessName: 'Business Name',
      cif: 'CIF',
      companyData: 'Company information',
      contactData: 'Contact information',
      attorneyData: 'Attorney information',
      documentsData: 'Documents',
      photosData: 'Photos',
      companyName: 'Business name',
      constitutionDate: 'Constitution Date',
      fax: 'Fax',
      registeredOffice: 'Registered Office',
      signType: 'Tipo de firma',
      phone: 'Phone',
      selectFile: 'Select File',
      providerComment: 'Act comments',
      driverProviderComment: 'Act comments - Concession',
      driverDriverComment: 'Act comments - Driver',
      cancelModalTitle: 'Cancel act',
      loadingModalTitle: 'Processing...',
      cancelModalText: 'Are you sure you want to cancel the act?',
      cancelModalInputLabel: 'Enter the reason for the cancellation',
      documentInvalid: 'Documents invalid.',
      checksMessageModalTitle: 'Save',
      checksMessageModalText:
        'You have not marked all the checks in any of the Delivered Documentation and Delivered Equipment sections, but if you want to continue, click on the Accept button. Also remember that you can leave us a comment so that we can communicate with the driver',
      dataSavedOk: 'The data has been saved successfully',
      errorValidationProcess: 'Validation process failed.',
      advice: 'Important announcement!',
      errorIdentityDefault:
        'With the data you have provided us there is no active driver. If you wish, contact us. Thank you.',
      actSigned: 'Act Signed',
      signLoadingText:
        'Your signature is being processed. Please do not close the browser, it may take several seconds.',
      showFilesModal: {
        title: 'Documents uploaded',
        error: 'Error'
      },
      showFiles: 'Show files',
      userName: 'Username',
      password: 'Password',
      usualDriver: 'Usual driver',
      damagesCarModal: {
        title: 'Damages in ',
        description: 'Damage description'
      },
      contractNumber: 'Contract number',
      initialDate: 'Initial date',
      finalDate: 'End date',
      startDate: 'Date start contract',
      rentDate: 'Date start rent',
      endDate: 'Date end rent',
      order: 'Order number',
      estimatedDuration: 'Estimated rental duration (months)',
      newVehicleDuration: 'Duration of rent with new vehicle subject to cancellation',
      contractKm: 'Hired kilometers',
      generalConditions: 'General conditions',
      particularConditions: 'Particular conditions',
      plate: 'Plate',
      model: 'Model',
      leftTyreDepth: 'Prof. Left',
      rightTyreDepth: 'Prof. Right',
      fuel: 'Fuel',
      numberPlaces: 'Nº Places',
      itvDate: 'ITV in force until',
      insuranceDate: 'Insurance in force until',
      fuelTank: 'Fuel tank',
      cleaningVehicle: 'Vehicle cleaning',
      wheels: 'Wheels',
      camps: 'Camps',
      camp: 'Camp',
      status: 'Status',
      category: 'Category',
      type: 'Type',
      width: 'Width',
      height: 'Height',
      diameter: 'Diameter',
      loadCode: 'Load code',
      speedCode: 'Speed code',
      obsIntDamage: 'Observations interior damage',
      obsExtDamage: 'Observations exterior damage',
      obsIntMechanical: 'Mechanical observations',
      idPap: 'Id PAP',
      driver: 'Driver',
      provider: 'Proveedor',
      idTransport: 'Id transporte'
    },
    table: {
      fields: {
        client: 'Client',
        contract: 'Contract',
        status: 'Status',
        plate: 'Plate',
        location: 'Location',
        typeCheck: 'Type of check',
        brand: 'Brand',
        model: 'Model',
        color: 'Color',
        kilometers: 'Kilometers',
        substate: 'Substate',
        dateCheck: 'Date of check',
        category: 'Category',
        stateDate: 'State date',
        tasks: 'Tasks',
        id: 'Id',
        camp: 'Campa',
        type: 'Type',
        description: 'Description',
        estimatedDate: 'Estimated date',
        documentation: 'Documentation',
        accessories: 'Accessories',
        damages: 'Damages',
        tuning: 'Tuning',
        vehicleState: 'Vehicle state',
        origin: 'Origin',
        destination: 'Destination',
        roundTrip: 'Round trip',
        dateTime: 'Date and time',
        driver: 'Driver',
        action: 'Action',
        logistic: 'Logistic',
        provider: 'Provider',
        idTransport: 'Id transport',
        pap: 'PAP',
        contactName: 'Contact',
        contactPhone: 'Contact phone'
      },
      actions: {
        seeTasks: 'See tasks',
        assignDriver: 'Assign driver',
        editDriver: 'Edit driver',
        transportAccept: 'Accept transport',
        transportDeny: 'Cancel transport',
        transportUnassign: 'Unassign transport',
        accessAct: 'Access act',
        passStatusToFinished: 'Pass status to finished',
        discrepancyDetail: 'Discrepancy detail'
      },
      warnings: {
        assignDriver: 'Driver cannot be assigned to a transport in a state other than Accepted',
        transportAccept:
          'Transportation cannot be accepted in a state other than Pending Acceptance.',
        transportDeny:
          'Transportation cannot be canceled in a state other than Pending Acceptance.',
        transportUnassign: 'Transport cannot be unassigned in a state other than Pending Assigned.',
        notAssigned: 'Not assigned',
        accessAct: 'They do not meet the requirements to access the record',
        passStatusToFinished:
          'You cannot go to finished if the status is different from Discrepancies or Delivered',
        campTransportAccept:
          'The status must be in discrepancies or delivered to execute this action',
        discrepancyDetail: 'No discrepancies available'
      }
    },
    modal: {
      title: {
        getPapsError: 'ERROR GETTING PAPS',
        getTransportError: 'ERROR GETTING TRANSPORTS',
        getDriverError: 'ERROR GETTING DRIVERS',
        confirmTransportEnd: 'CONFIRM TRANSPORT END',
        confirmTransportAccept: 'CONFIRM TRANSPORT ACCEPT',
        confirmTransportDeny: 'CONFIRM TRANSPORT DENY',
        confirmTransportREJECT: 'CONFIRM TRANSPORT REJECT',
        confirmTransportUnassign: 'CONFIRM TRANSPORT UNASSIGN',
        cancelAssociated: 'CANCEL ASSOCIATED ACT'
      },
      text: {
        confirmTransportEnd: 'Are you sure you want to finish the transport?',
        confirmTransportAccept: 'Are you sure you want to accept the transport?',
        confirmTransportDeny: 'Are you sure you want to deny the transport?',
        confirmTransportReject: 'Are you sure you want to reject the transport?',
        confirmTransportUnassign: 'Are you sure you want to unassign the transport?'
      }
    }
  },
  literals: {
    fileUploader: {
      maxFilesExceeded: 'You cannot select more than {maxFiles} files.',
      fileSizeExceeded: 'The file {fileName} exceeds the allowed size of {maxSize}MB.',
      totalSizeExceeded:
        'We could not load the file because it exceeds the limit set of {maxSize}MB',
      processError: 'Error processing the file.',
      warningMaxFiles: 'Select a maximum of {maxFiles} files.',
      warningTotalSize: 'The total weight should not exceed {maxSize}MB.',
      warningGeneric: 'Select a file or a set of them.',
      badgeMaxFiles: 'Files: {preloadedFiles} / {maxFiles}',
      badgeTotalSize: 'Size: {sizePreloaded} / {maxWeightPreloaded}MB'
    }
  }
};
